import { Injectable } from '@angular/core';
import { UserDto } from '../../../auth/user.dto';
import { Clearances } from '../../../shared/models/enums/clearance.enum';
import { TInboxPermission } from '../permissions';

@Injectable({
  providedIn: 'root',
})
export class InboxPermissionService {
  public getPermissions(user: UserDto): TInboxPermission[] {
    const [group]: string[] = user?.groups;
    switch (group) {
      case 'STRUCTURE':
        return ['INBOX_CAN_ACCESS'];
      case 'DIRECTION+':
        return (
          user.clearances?.reduce((all: TInboxPermission[], clearance: string) => {
            let permissions: TInboxPermission[];
            switch (clearance) {
              // Contracts IER
              case Clearances.CLR_VALIDATOR_IER:
                permissions = ['INBOX_CAN_ACCESS'];
                break;
              case Clearances.CLR_SIGNATORY_IER:
                permissions = ['INBOX_CAN_ACCESS', 'INBOX_CAN_SIGN'];
                break;

              // Contracts socio pro
              case Clearances.CLR_VALIDATOR_SOCIO_PRO:
                permissions = ['INBOX_CAN_ACCESS'];
                break;
              case Clearances.CLR_SIGNATORY_SOCIO_PRO:
                permissions = ['INBOX_CAN_ACCESS', 'INBOX_CAN_SIGN'];
                break;

              // Contracts RSJ
              case Clearances.CLR_VALIDATOR_RSJ:
                permissions = ['INBOX_CAN_ACCESS', 'INBOX_CAN_SIGN'];
                break;

              default:
                permissions = [];
                break;
            }
            return Array.from(new Set([...all, ...permissions]));
          }, []) || []
        );
      default:
        return [];
    }
  }
}
